import React from "react";
import { AlertTriangle } from "lucide-react";
import { WarehouseCheckInFlaggedIssue } from "src/types";
import { NoteDisplay } from "src/components";

interface CheckInFlaggedIssuesPanelProps {
  flaggedIssues?: WarehouseCheckInFlaggedIssue[];
}

export const CheckInFlaggedIssuesPanel: React.FC<CheckInFlaggedIssuesPanelProps> = ({ flaggedIssues }) => {
  if (!flaggedIssues || flaggedIssues.length === 0) return null;

  return (
    <div className="bg-error-50 border border-error-200 rounded-lg p-4">
      <div className="flex items-start space-x-3">
        <AlertTriangle className="w-5 h-5 text-error-600 mt-0.5 flex-shrink-0" />
        <div className="flex-1">
          <p className="text-sm font-semibold text-error-800 mb-3">Flagged Issues</p>
          <div className="space-y-2">
            {flaggedIssues.map((issue, index) => (
              <div key={index} className="text-sm text-error-700 leading-relaxed">
                <NoteDisplay note={{ body: issue, date: "" }} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
